import { RemoveRedEyeOutlined } from '@mui/icons-material';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { useNavigate } from 'react-router-dom';
import { IMaterial } from '../../../utils/entities/interface';
import { ListTable } from '../../molecules/ListTable';

export const MaterialList = ({
  material,
  isLoading,
  headerCells,
  setAddMaterial,
  setFormData,
}: {
  material: IMaterial[];
  isLoading: boolean;
  headerCells: [string, number][];
  setAddMaterial: any;
  setFormData: any;
}) => {
  const actions = [
    // {
    //   icon: <RemoveRedEyeOutlined />,
    //   onClick: (row: IMaterial) => window.open(`/manage/services/${row._id}`),
    // },
    {
      icon: <BorderColorOutlinedIcon />,
      onClick: (row: IMaterial) => {
        setAddMaterial(true);
        setFormData({
          id: row._id,
          name: row.name,
          price: row.rate,
          unit: row.unit,
          status: row.status,
        });
      },
    },
  ];

  return (
    <ListTable
      headerCells={headerCells}
      rows={material}
      isLoading={isLoading}
      actions={actions}
      renderCell={(material: IMaterial, colIndex: number) => {
        switch (colIndex) {
          case 0:
            return material.name;
          case 1:
            return material.unit;
          case 2:
            return material.rate;
          case 3:
            return (
              <span
                className={
                  material.status !== 'ACTIVE' ? 'inActiveClass' : 'activeClass'
                }
              >
                {material.status == 'ACTIVE' ? 'Active' : 'Inactive'}
              </span>
            );
          default:
            return null;
        }
      }}
    />
  );
};
